import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {getResolvedFeatureFlags} from "@pg-mono/amplitude";
import type {IDevToolsConfig} from "@pg-mono/devtools";
import {getCookie} from "@pg-mono/request";

import {ongoingABTests} from "../common/ab_testing/ongoing_ab_tests";
import {amplitudeApiKey, buildImageTag, rpFeatureFlagDevtools} from "../common/app/read_rp_environment_variables";
import {IRootState} from "../common/store/store";
import {selectUserProfile} from "../common/user/api/get_user_profile";

declare global {
    interface Window {
        __AMPLITUDE_FETCHED_FLAGS__?: string[];
    }
}

const FORCE_COOKIE = "pg-devtools-force";

const getABTestCurrentVariant = (testId: string, variants: string[]): string | null => {
    const cookieValue = getCookie(testId);

    if (cookieValue === null) {
        return null;
    }

    // Legacy cookies may store variant index instead of name - resolve to name
    const index = parseInt(cookieValue, 10);

    if (String(index) === cookieValue && index >= 0 && index < variants.length) {
        return variants[index];
    }

    return cookieValue;
};

const getAmplitudeUserId = (state?: IRootState): string | undefined => {
    try {
        const appState = state ?? (window as {__INITIAL_STATE__?: IRootState}).__INITIAL_STATE__;

        if (!appState) {
            return undefined;
        }

        const userProfileResult = selectUserProfile(appState);
        const userId = userProfileResult?.data?.id;

        return userId ? String(userId) : undefined;
    } catch {
        return undefined;
    }
};

const handleDevtoolsSearchParam = () => {
    const params = new URLSearchParams(window.location.search);
    const devtoolsParam = params.get("pgdevtools");

    if (devtoolsParam === "1" || devtoolsParam === "true") {
        document.cookie = `${FORCE_COOKIE}=1; path=/; max-age=${60 * 60 * 24 * 365}`;
    } else if (devtoolsParam === "0" || devtoolsParam === "false") {
        document.cookie = `${FORCE_COOKIE}=0; path=/; max-age=${60 * 60 * 24 * 365}`;
    }
};

export const initRpDevtools = (state?: IRootState) => {
    handleDevtoolsSearchParam();

    const cookieValue = getCookie(FORCE_COOKIE);
    // Cookie overrides env var when set: "1" forces ON, "0" forces OFF
    const isEnabled = cookieValue !== null ? cookieValue === "1" : rpFeatureFlagDevtools;
    const isForced = cookieValue === "1";

    if (!isEnabled) {
        return;
    }

    const amplitudeFetchedFlags = window.__AMPLITUDE_FETCHED_FLAGS__ ?? [];
    delete window.__AMPLITUDE_FETCHED_FLAGS__;

    const config: IDevToolsConfig = {
        isForced,
        buildImageTag,
        amplitude: {
            isInitialized: Boolean(amplitudeApiKey),
            apiKeyHint: amplitudeApiKey ? amplitudeApiKey.slice(-4) : undefined,
            deviceId: getCookie("analyticssessionid") ?? undefined,
            userId: getAmplitudeUserId(state)
        },
        abTests: ongoingABTests.map((test: IABTestConfiguration) => ({
            id: test.id,
            name: test.name,
            expires: test.expires,
            path: test.path,
            matchOnAllPaths: test.matchOnAllPaths,
            variants: test.variants,
            withSSR: test.withSSR,
            useAmplitude: test.useAmplitude,
            amplitudeVariantAvailable: test.useAmplitude ? amplitudeFetchedFlags.includes(test.id) : undefined,
            currentVariant: getABTestCurrentVariant(test.id, test.variants)
        })),
        featureFlags: Object.values(getResolvedFeatureFlags()),
        envVars: window.__INITIAL_ENV__
    };

    import("@pg-mono/devtools").then(({initDevTools}) => {
        initDevTools(config);
    });
};
import type {IABTestConfiguration} from "@pg-mono/ab-testing";
import {getResolvedFeatureFlags} from "@pg-mono/amplitude";
import type {IDevToolsConfig} from "@pg-mono/devtools";
import {getCookie} from "@pg-mono/request";

import {ongoingABTests} from "../common/ab_testing/ongoing_ab_tests";
import {amplitudeApiKey, buildImageTag, rpFeatureFlagDevtools} from "../common/app/read_rp_environment_variables";
import {IRootState} from "../common/store/store";
import {selectUserProfile} from "../common/user/api/get_user_profile";

declare global {
    interface Window {
        __AMPLITUDE_FETCHED_FLAGS__?: string[];
    }
}

const FORCE_COOKIE = "pg-devtools-force";

const getABTestCurrentVariant = (testId: string, variants: string[]): string | null => {
    const cookieValue = getCookie(testId);

    if (cookieValue === null) {
        return null;
    }

    // Legacy cookies may store variant index instead of name - resolve to name
    const index = parseInt(cookieValue, 10);

    if (String(index) === cookieValue && index >= 0 && index < variants.length) {
        return variants[index];
    }

    return cookieValue;
};

const getAmplitudeUserId = (state?: IRootState): string | undefined => {
    try {
        const appState = state ?? (window as {__INITIAL_STATE__?: IRootState}).__INITIAL_STATE__;

        if (!appState) {
            return undefined;
        }

        const userProfileResult = selectUserProfile(appState);
        const userId = userProfileResult?.data?.id;

        return userId ? String(userId) : undefined;
    } catch {
        return undefined;
    }
};

const handleDevtoolsSearchParam = () => {
    const params = new URLSearchParams(window.location.search);
    const devtoolsParam = params.get("pgdevtools");

    if (devtoolsParam === "1" || devtoolsParam === "true") {
        document.cookie = `${FORCE_COOKIE}=1; path=/; max-age=${60 * 60 * 24 * 365}`;
    } else if (devtoolsParam === "0" || devtoolsParam === "false") {
        document.cookie = `${FORCE_COOKIE}=0; path=/; max-age=${60 * 60 * 24 * 365}`;
    }
};

export const initRpDevtools = (state?: IRootState) => {
    handleDevtoolsSearchParam();

    const cookieValue = getCookie(FORCE_COOKIE);
    // Cookie overrides env var when set: "1" forces ON, "0" forces OFF
    const isEnabled = cookieValue !== null ? cookieValue === "1" : rpFeatureFlagDevtools;
    const isForced = cookieValue === "1";

    if (!isEnabled) {
        return;
    }

    const amplitudeFetchedFlags = window.__AMPLITUDE_FETCHED_FLAGS__ ?? [];
    delete window.__AMPLITUDE_FETCHED_FLAGS__;

    const config: IDevToolsConfig = {
        isForced,
        buildImageTag,
        amplitude: {
            isInitialized: Boolean(amplitudeApiKey),
            apiKeyHint: amplitudeApiKey ? amplitudeApiKey.slice(-4) : undefined,
            deviceId: getCookie("analyticssessionid") ?? undefined,
            userId: getAmplitudeUserId(state)
        },
        abTests: ongoingABTests.map((test: IABTestConfiguration) => ({
            id: test.id,
            name: test.name,
            expires: test.expires,
            path: test.path,
            matchOnAllPaths: test.matchOnAllPaths,
            variants: test.variants,
            withSSR: test.withSSR,
            useAmplitude: test.useAmplitude,
            amplitudeVariantAvailable: test.useAmplitude ? amplitudeFetchedFlags.includes(test.id) : undefined,
            currentVariant: getABTestCurrentVariant(test.id, test.variants)
        })),
        featureFlags: Object.values(getResolvedFeatureFlags()),
        envVars: window.__INITIAL_ENV__
    };

    import("@pg-mono/devtools").then(({initDevTools}) => {
        initDevTools(config);
    });
};
